<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="老师名称:">
          <el-input v-model="listQuery['filter[name]']" placeholder="老师名称" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
          <el-button type="success" size="medium" @click="handleAdd">新增</el-button>
          <el-button size="medium"><a style="color:#606266 " :href="GLOBAL.BASE_URL+'download/teacher.xlsx'">下载模板</a>
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-upload
            class="upload-demo"
            action=""
            :show-file-list="false"
            :http-request="upload"
            :on-success="handleImageSuccess"
            :on-error="handleImageError"
          >
            <el-button size="medium" type="info">导入老师</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="name" label="姓名">
      </el-table-column>
      <el-table-column prop="mobile" label="联系电话">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="warning" size="small" @click="handleEdit(scope)">编辑</el-button>
          <el-button type="danger" size="small" @click="handleDelete(scope)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page"
                  @pagination="getData"/>

    </div>
    <el-dialog :visible.sync="dialogVisible" :title="dialogType==='edit'?'编辑考官':'新增考官'">
      <el-form :model="teacherInfo" label-width="80px" label-position="left" ref="teacherForm" :rules="ruless">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="teacherInfo.name" placeholder="姓名" @input="change($event)"></el-input>
        </el-form-item>
        <el-form-item label="头像" prop="avatar">
          <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
                     :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :data="{type:'avatar'}">
            <img v-if="teacherInfo.avatar" :src="GLOBAL.BASE_URL+teacherInfo.avatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="teacherInfo.gender">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="教师编号">
          <el-input v-model="teacherInfo.code" placeholder="教师编号" @input="change($event)"></el-input>
        </el-form-item>

        <el-form-item label="身份证号" prop="idcard">
          <el-input v-model="teacherInfo.idcard" placeholder="身份证号" @input="change($event)"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="mobile">
          <el-input v-model="teacherInfo.mobile" placeholder="联系电话" @input="change($event)"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="teacherInfo.email" placeholder="邮箱" @input="change($event)"></el-input>
        </el-form-item>
        <el-form-item label="支持项目" prop="subjects">
          <el-select v-model="teacherInfo.subjects" multiple placeholder="请选择">
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button type="danger" @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="confirmSave('teacherForm')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'

    export default {
        components: {Pagination},
        props: {},
        data() {
            return {
                uploadUrl: this.GLOBAL.BASE_URL + 'api/images',
                teacherInfo: {
                    name: '',
                    mobile: '',
                    email: '',
                    code: '',
                    idcard: '',
                    avatar: '',
                    gender: 1
                },
                subjectList: [],
                total: 0,
                dialogType: 'new',
                dialogVisible: false,
                listQuery: {
                    page: 1,
                    per_page: 20
                },
                tableData: [],
                ruless: {
                    name: [
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                        {min: 2, max: 10, message: '长度在2到10个字符', trigger: 'blur'},
                        {
                            required: true,
                            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
                            message: '姓名不支持特殊字符',
                            trigger: 'change'
                        },

                    ],
                    idcard: [
                        {
                            required: false,
                            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                            message: '请输入正确的身份证号码',
                            trigger: 'change'
                        }
                    ],

                    email: [
                        {required: false, message: '请输入邮箱地址', trigger: 'blur'},
                        {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}

                    ],
                    mobile: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {required: true, pattern: /^1[34578]\d{9}$/, message: '目前只支持中国大陆的手机号码', trigger: 'blur'},

                    ],
                    subjects: [
                        {required: true, message: '请选择支持考试项目', trigger: 'blur'}
                    ],

                },
            };
        },
        computed: {},
        created() {
            this.getData();
            this.getSubject()
        },
        methods: {
            change(e) {
                this.$forceUpdate()
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            handleAvatarSuccess(res, file) {
                this.teacherInfo.avatar = res.data.path
                console.log(res.data.path)
            },
            upload(file, detail) {
                // 根据后台需求数据格式
                const form = new FormData();
                // 文件对象
                form.append("file", file.file);
                this.$http.importTeacher(form).then(response => {
                    this.getData();
                }).catch(err => {
                    this.$message.info(err.message)
                })


            },
            handleImageSuccess(file) {
                console.log(file)
            },
            handleImageError(err, file, fileList) {
                console.log(err)
            },
            getSubject() {
                this.$http.allSubjects().then(res => {
                    const data = [];
                    res.data.forEach(function (i) {
                        data.push({
                            id: i.id,
                            name: i.name
                        })
                    })
                    this.subjectList = data;
                    console.log(this.subjectList)
                })
            },
            search() {
                this.listQuery.page = 1;
                this.getData()
            },
            // 获取全部的课程列表
            getData() {
                this.$http.getTeachers(this.listQuery)
                    .then(res => {
                        this.tableData = res.data;
                        this.total = res.meta.total;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleAdd() {
                this.teacherInfo = {
                    name: '',
                    mobile: '',
                    email: '',
                    code: '',
                    idcard: '',
                    avatar: '',
                    gender: 1
                };
                this.dialogType = 'new';
                this.dialogVisible = true
            },
            handleEdit(scope) {
                this.$http.getTeacher(scope.row.id, {include: 'subjects,user'}).then(res => {
                    if (res.data) {
                        const subjects = [];
                        this.teacherInfo.id = res.data.id
                        this.teacherInfo.name = res.data.name
                        this.teacherInfo.mobile = res.data.mobile
                        this.teacherInfo.email = res.data.user.email
                        this.teacherInfo.code = res.data.user.code
                        this.teacherInfo.idcard = res.data.user.idcard
                        this.teacherInfo.avatar = res.data.user.avatar
                        this.teacherInfo.gender = res.data.user.gender
                        res.data.subjects.forEach((i, v) => {
                            subjects.push(i.id)
                        })
                        this.teacherInfo.subjects = subjects
                        this.dialogType = 'edit';
                        this.dialogVisible = true;
                    }

                })
            },
            confirmSave(formName) {
                const isEdit = this.dialogType === 'edit'
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (isEdit) {
                            this.$http.updateTeacher(this.teacherInfo.id, this.teacherInfo).then(res => {
                                this.dialogVisible = false
                                this.$notify({
                                    title: 'Success',
                                    message: '操作成功！',
                                    type: 'success'
                                })
                                this.getData()
                            })
                        } else {
                            this.$http.addTeacher(this.teacherInfo).then(res => {
                                this.dialogVisible = false
                                this.$notify({
                                    title: 'Success',
                                    message: '操作成功！',
                                    type: 'success'
                                })
                                this.getData()
                            })
                        }
                    }
                });

            },
            handleDelete({$index, row}) {
                this.$confirm('确定要删除此条吗?', '警告', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http.deleteTeacher(row.id).then(res => {
                            this.tableData.splice($index, 1)
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                        });

                    })
                    .catch(err => {
                        console.error(err)
                    })
            },

        },
    };
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/page/resourceManage/teachers.vue